import "./PageNotFound.css";

function PageNotFound() {
    return (
        <div id="ErrorpageDiv">
            <div id="ErrorpageBox">
                <h1 id="ErrorTitle">Error 404</h1>
                <p id="ErrorText">Page not found, close the page and try again</p>
            </div>
        </div>
    )
}

export default PageNotFound;